import {
  Component,
  Input,
  OnDestroy,
  ChangeDetectorRef
} from '@angular/core';
import { Subject, takeUntil } from 'rxjs';
import { SpinService } from '../../core/spin.service';

@Component({
  standalone: false,
  selector: 'spin',
  templateUrl: './spin.component.html'
})
export class SpinComponent implements OnDestroy {

  @Input() visible: boolean = false;
  @Input() diameter: number = 100;
  @Input() strokeWidth: number = 10;

  private ngUnsubscribe = new Subject<void>();

  constructor(
    private spinService: SpinService,
    private changeDetectionRef: ChangeDetectorRef
  ) {
    this.spinService.spinnerStates
      .pipe(takeUntil(this.ngUnsubscribe))
      .subscribe((state) => {
        this.visible = state;
        this.changeDetectionRef.detectChanges();
      });
  }

  ngOnDestroy(): void {
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }
}
